import { useState } from 'react'
import { TitleDivider } from '@/components/TitleDivider'
import { contentMap } from 'utils/contentful'
import { StickySwitchTabs } from './StickySwitchTabs'
import { DebtSolutionsCards } from './DebtSolutionsCards'
import { ArticlesTab } from './ArticlesTab'
import { Carousel } from '@/components/Carousels'
import Section from '@/components/Section'
import { Typography } from '@/components/Contentful'

function LendingDebtSolutions({ content }) {
  const [selectedTab, setSelectedTab] = useState(0)

  const { relatedContentCollection } = content.fields

  const memoizedContent = contentMap(content?.fields?.sectionContents || [], [
    'title',
    'eyebrowMobile',
    'eyebrow',
    'firstTab',
    'secondTab',
    'thirdTab',
    'solutionsCards',
    'appCards',
    'config',
  ])
  const {
    title,
    eyebrowMobile,
    eyebrow,
    firstTab,
    secondTab,
    thirdTab,
    solutionsCards,
    appCards,
    config,
  } = memoizedContent

  const values = Object.values({
    title,
    eyebrowMobile,
    eyebrow,
    firstTab,
    secondTab,
    thirdTab,
    solutionsCards,
    appCards,
    config,
  })

  if (values.some((v) => v === undefined)) {
    return null
  }

  const hideTabs = config?.jsonContent?.hideTabs || false
  const indicatorDotsClass = config?.jsonContent?.classNameIndicatorDots || 'bg-[#3300ff]'
  const showMobileRow = config?.jsonContent?.showMobileRow || false

  let tabs = [firstTab, secondTab, thirdTab]

  tabs = tabs.map((tab, idx) => {
    return {
      tabLabel: tab?.textContent?.json?.content[0]?.content[0]?.value,
      tabItem: (
        <>
          <h1>{`${idx}`}</h1>
        </>
      ),
    }
  })

  return (
    <Section
      className="relative mb-[48px] md:mb-[64px] "
      data-testid="lending-debt-solutions-section"
    >
      <TitleDivider
        className="pt-[48px] md:pt-[88px] mb-7!"
        title={title}
        eyebrow={eyebrow}
        eyebrowBlack
      />

      {!hideTabs && (
        <div className="sticky top-[54px] lg:top-[64px] z-10 bg-white">
          <StickySwitchTabs tabs={tabs} selectedTab={setSelectedTab} />
        </div>
      )}

      {selectedTab === 0 && solutionsCards && (
        <>
          <div className="hidden lg:flex justify-center items-center gap-[40px] mt-[40px]">
            {solutionsCards.gridItemsCollection.items.map((card) => {
              return <DebtSolutionsCards fixedH={true} key={card?.sys?.id} card={card} />
            })}
          </div>
          {showMobileRow ? (
            <div className="flex lg:hidden flex-col gap-2 mt-[26px] mb-[23px] items-center">
              {solutionsCards.gridItemsCollection.items.map((card) => {
                return (
                  <DebtSolutionsCards
                    key={card?.sys?.id}
                    card={card}
                    containerClassName="w-full px-6 rounded-[10px] bg-[#F8F9FC] mx-[23px] my-[23px]"
                    itemsPadding="px-[18px]"
                    buttonClassName="text-[13px] px-[24px] py-[14px] min-h-10 lg:min-h-12 lg:text-[18px] max-h-12 min-w-[250px]"
                  />
                )
              })}
            </div>
          ) : (
            <Carousel
              carouselItems={solutionsCards.gridItemsCollection.items}
              itemComponent={({ item }) => {
                return <DebtSolutionsCards key={item?.sys?.id} card={item} />
              }}
              idPrefix="value-props-carousel"
              className="p-0 pl-0! lg:hidden mt-[26px] mb-[23px]"
              withIndicators
              variant="center"
              variationDot="onWhite"
              classNameIndicatorDots={indicatorDotsClass}
              classNameIndicators="mt-0!"
              classNameWrapper="mt-0! !sm:mt-[23px] flex md:hidden"
              peek={true}
            />
          )}
          <Typography
            className="mb-[20px] mt-[23px] text-(--content-state-primary-hover,#5C708A) text-center font-ultramarine text-[12px] font-normal leading-[140%]"
            content={"Checking is quick, secure, and won't affect your credit score"}
            data-testid="lending-debt-solutions-closer-copy"
          />
        </>
      )}
      {selectedTab === 1 && appCards && (
        <>
          <div className="hidden lg:flex justify-center items-start gap-[40px] mt-[40px] md:mb-[20px]">
            {appCards.gridItemsCollection.items.map((card) => {
              return <DebtSolutionsCards fixedH={true} key={card?.sys?.id} card={card} />
            })}
          </div>
          <div className="flex flex-col justify-center w-full">
            {showMobileRow ? (
              <div className="flex md:hidden flex-col gap-2 mt-[26px] mb-[23px]">
                {appCards.gridItemsCollection.items.map((card) => {
                  return (
                    <DebtSolutionsCards
                      key={card?.sys?.id}
                      card={card}
                      containerClassName="w-full md:w-[336px]"
                      itemsPadding="px-[18px]"
                      buttonClassName="w-[88%] text-[13px] px-[24px] py-[14px] min-h-10 lg:min-h-12 lg:text-[18px] mx-auto max-h-12 lg:min-w-[179px]"
                    />
                  )
                })}
              </div>
            ) : (
              <Carousel
                carouselItems={appCards.gridItemsCollection.items}
                itemComponent={({ item }) => {
                  return <DebtSolutionsCards key={item?.sys?.id} card={item} />
                }}
                idPrefix="value-props-carousel"
                className="p-0 pl-0! lg:hidden mt-[26px] mb-[23px]"
                withIndicators
                variant="center"
                variationDot="onWhite"
                classNameIndicatorDots={indicatorDotsClass}
                classNameIndicators="mt-0! !sm:mt-[23px]"
                classNameWrapper="mt-0! !sm:mt-[23px] flex md:hidden mb-[20px]"
                peek={true}
              />
            )}
          </div>
        </>
      )}
      {selectedTab === 2 && relatedContentCollection && config && (
        <>
          <ArticlesTab list={relatedContentCollection?.items} config={config} />
        </>
      )}
    </Section>
  )
}

export { LendingDebtSolutions }
export default LendingDebtSolutions
